import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { Search as IconSearch } from "@mui/icons-material";

import { getsAutorizacion } from "../../services/autorizacionService";
import DataGridBase from "../../components/common/DataGridBase";
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Aprobaciones: las acciones que se autorizaron con el usuario y la clave de
// alguien que tiene el acceso. De cada una queda la entidad, su id, el detalle,
// la accion, la fecha y la hora y quien la aprobo.
const Index = () => {
    useMantenimiento("autorizacion");

    const today = () => moment().format('yyyy-MM-DD');

    const [filters, setFilters] = useState({
        fechaInicio: today(),
        fechaFin: today(),
        entidad: "",
        accion: "",
        usuario: "",
    });

    const [results, setResults] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchResults = useCallback(async () => {
        setCargando(true);

        // Las fechas van en hora local: con toISOString se correrian un dia.
        const fechaInicio = filters.fechaInicio
            ? moment(filters.fechaInicio).startOf("day").format("YYYY-MM-DD HH:mm:ss")
            : null;
        const fechaFin = filters.fechaFin
            ? moment(filters.fechaFin).endOf("day").format("YYYY-MM-DD HH:mm:ss")
            : null;

        const data = await getsAutorizacion({
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            entidad: filters.entidad == null ? "" : filters.entidad,
            accion: filters.accion == null ? "" : filters.accion,
            usuario: filters.usuario == null ? "" : filters.usuario,
        }).catch((err) => { console.log("Err: ", err) });

        // El grid pide un id unico por fila.
        setResults((data || []).map((row) => ({ ...row, id: row.idAutorizacion })));
        setCargando(false);
    }, [filters])

    useEffect(() => {
        fetchResults();
    }, [fetchResults])

    const columns = [
        { field: 'fechaHora', headerName: 'Fecha y Hora', width: 140, type: 'date'
            , valueFormatter: (value) => moment(value).format('D/MM/YYYY HH:mm')
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'entidad', headerName: 'Entidad', width: 150, sortable: false, headerAlign: 'left' },
        { field: 'idEntidad', headerName: 'Id', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'detalle', headerName: 'Detalle', width: 170, sortable: false, headerAlign: 'left' },
        { field: 'accion', headerName: 'Accion', width: 150, sortable: false, headerAlign: 'left' },
        { field: 'usuario', headerName: 'Usuario que aprobo', width: 160, sortable: false, headerAlign: 'left' },
        { field: 'observaciones', headerName: 'Observaciones', width: 220, sortable: false, headerAlign: 'left' },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Autorizaciones
                    </Typography>
                </Grid>
                <Grid container spacing={1} alignItems={"center"} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="fechaInicio"
                            label="Fecha Desde"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={filters.fechaInicio}
                            onChange={(event) => setFilters({ ...filters, fechaInicio: event.target.value })}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="fechaFin"
                            label="Fecha Hasta"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            value={filters.fechaFin}
                            onChange={(event) => setFilters({ ...filters, fechaFin: event.target.value })}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="entidad"
                            label="Entidad"
                            value={filters.entidad}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, entidad: event.target.value })}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="accion"
                            label="Accion"
                            value={filters.accion}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, accion: event.target.value })}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="usuario"
                            label="Usuario"
                            value={filters.usuario}
                            fullWidth
                            onChange={(event) => setFilters({ ...filters, usuario: event.target.value })}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2} display={"flex"} alignItems={"center"}>
                        <Button variant="outlined" size="medium" fullWidth onClick={() => { fetchResults() }}>
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase rows={results} columns={columns} loading={cargando} />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default Index;
